import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { GroupParticipant } from '../../_interfaces/group-participant.interface';
import { CalibrationService } from '../../calibration.service';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
  selector: 'app-calibration-user-comment',
  templateUrl: './user-comment.modal.html',
  styleUrls: ['./user-comment.modal.scss']
})
export class CalibrationUserCommentModal extends BaseClass implements OnInit {
  public currentRank: string;
  public user: GroupParticipant;
  public cycleId: number;

  public evaluationLog = [];

  public selectedLanguage = this._translationService.getSelectedLanguage();
  public useTranslationOnOverallEvaluation: boolean;
  public showNamedPromotionAndPriority: boolean;

  private _groupId: number;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    private _modalController: ModalController,
    private _navParams: NavParams,
    private _calibrationService: CalibrationService,
    private _configService: ConfigService
  ) {
    super(_toastController, _translationService);
    this.user = this._navParams.get('user');
    this._groupId = this._navParams.get('groupId');
  }

  ngOnInit(): void {
    this.useTranslationOnOverallEvaluation = this._configService.settings.features.useTranslationOnOverallEvaluation;
    this.showNamedPromotionAndPriority = this._configService.settings.features.showNamedPromotionAndPriority;
    this.currentRank = this.user.rank;
    
    if(!this.showNamedPromotionAndPriority){
        this._calibrationService.getParticipantEvaluationLog(this.cycleId, this.user.userId, this.selectedLanguage)
        .subscribe((res) => this.evaluationLog = res.data);
    }
    
  }

  public dismiss(): void {
    this._modalController.dismiss();
  }

  public save(): void {
    this._calibrationService.updateCalibrationGroupUserNotes(
      this._groupId, this.user.userId,
      this.user.notes, this.user.inReview,
      this.user.reviewNote
    ).subscribe(() => {
      this.notifySuccess();
      this.dismiss();
    }, (error) => this.notifyError(error) );
  }
}
